import { render, staticRenderFns } from "./PublishPageViewerSetup.vue?vue&type=template&id=3d0b4515"
import script from "./PublishPageViewerSetup.vue?vue&type=script&lang=js"
export * from "./PublishPageViewerSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports